// @flow

import React from 'react'
import FooterBottom from './FooterBottom'

type PropTypes = {
  hasFooter?: boolean,
}

export default function Footer(props: PropTypes) {
  if (!props.hasFooter) {
    return null
  }

  return (
    <footer>
      <FooterBottom />
    </footer>
  )
}

Footer.defaultProps = {
  hasFooter: true,
}
